module.exports = __webpack_public_path__ + "static/img/19.c3484f41.png";